/* eslint-disable no-unused-vars */
/* eslint-disable */
$(document).ready( function() {
    $("#acf-field_5e451947a7c36").change( function(e) {
        e.preventDefault();

        var post_id = $(this).children("option:selected").val();
        $.ajax({
            type : "post",
            dataType : "json",
            url : myAjax.ajaxurl,
            data : {action: "get_school_grade", post_id : post_id},
            success: function(response) {
                if(response.type === 'success') {
                    $('.af-field-grade-level input[type="checkbox"]')
                        .prop( "checked", false )
                        .parent().removeClass('selected');

                    var i;
                    for (i = 0; i < response.data.length; ++i) {
                        var value = response.data[i];
                        console.log(value);
                        $('.af-field-grade-level input[value="'+ value +'"]')
                            .prop( "checked", true )
                            .parent().toggleClass('selected');
                    }
                } else {
                    $('.af-field-grade-level input[type="checkbox"]')
                        .prop( "checked", false )
                        .parent().removeClass('selected');
                    console.log('error getting grade level.');
                }
            }
        });
    });
});


// WEBPACK FOOTER //
// ./scripts/get_grade_level.js